export default __webpack_public_path__ + "static/media/AI Concierge.d77e2623.svg";